import moment from 'moment';
import { EligibleEmployeeRequestContract } from '../../types';
import { EligibilityData, EligibilityOption } from '../types';

export const getEmployeesChangingEligibility = (employees: EligibilityData[]): EligibleEmployeeRequestContract[] => {
	return employees.filter(employee => employee.eligibility === EligibilityOption.eligible).map(employee => ({ employeeId: employee.id, effectiveDate: moment(employee.effectiveDate).format('YYYY-MM-DD') }));
};
